module.exports = __webpack_public_path__ + "img/3.8b09a469.jpg";